<template>
  <div class="bm-invite-team" >
    <div class="team" >
      <div class="thumb">
        <img :src="icon">
      </div>
      <div>
        <p><span>赛事报名</span> - {{signUpRule.chineseName}}</p>
      </div>
    </div>
    <div class="main" >
      <div class="title" >
        报名须知:
      </div>
      <van-cell title="球队人数上限" :value="signUpRule.teamMemberLimitCount" />
      <van-cell title="报名费用" :value="entryFee" />
      <van-cell title="保证金" :value="deposit" />
      <van-cell title="报名截止" :value="endDate" />
    </div>
    <div class="foot" @click="routerApplyFro" >
      立即报名
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant'
import Vue from 'vue'
import { ImageFormat, formatDate } from '@/utils'
import { getBMMatchSignUpRule } from '@/api/match'
Vue.use({ Dialog })

export default {
  name: 'InviteTeam',
  data () {
    return {
      query: this.$route.query,
      signUpRule: {}
    }
  },
  computed: {
    entryFee: function() {
      return this.signUpRule.entryFee + '¥'
    },
    deposit: function() {
      return this.signUpRule.deposit + '¥'
    },
    endDate() {
      if (!this.signUpRule.regEndDate) {
        return ''
      }
      return formatDate(this.signUpRule.regEndDate)
    },
    icon() {
      return ImageFormat.squareImageView(this.signUpRule.icon, 104)
    }
  },
  created() {
    this.getBMMatchSignUpRule()
  },
  methods: {
    routerApplyFro: function () {
      if (this.signUpRule.allowTeamSignUp === 1) {
        this.$router.push({ name: 'InviteSignUp', query: {matchId: this.query.matchId} })
      } else {
        Dialog.alert({
          message: '赛事报名已关闭'
        }).then(() => {
          // on close
        })
      }
    },
    getBMMatchSignUpRule: function() {
      getBMMatchSignUpRule(this.query.matchId).then(response => {
        const data = response.data
        this.signUpRule = data.signUpRule
      })
    }
  }
}
</script>
<style lang="stylus" >
.bm-invite-team
  height: 100%
  .team
    display flex
    padding 15px
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:last-child
      width: calc(100% - 62px)
      p
        margin: 0;
        font-size:20px;
        font-weight:400;
        color:rgba(0,0,0,1);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      span
        font-weight:400;
        color:rgba(0,0,0,1);
        display inline
  .main
    .title
      padding: 15px;
      font-size:18px;
      font-weight:400;
      color:rgba(0,0,0,1);
  .van-cell:not(:last-child)::after
    right: 15px
  .van-cell:first-child
    .van-cell__title
      display flex
      align-content center
      align-items: center;
  .van-cell
    font-size:16px;
    font-weight:300;
    color:rgba(74,74,74,1);
    .van-icon::before
      color: #000000
  .foot
    padding: 10px 0
    background: rgba(250,250,250,1);
    text-align center
    position absolute
    bottom: 0
    width: 100%
    font-size:20px;
    font-weight:400;
    color:rgba(50,163,119,1);
</style>



// WEBPACK FOOTER //
// src/pages/invite/team.vue